import assign from 'object-assign';

import GenericStore from './GenericStore.js';

const notes = [
  {
    // left hand
    note: 'C',
    image: 'c-left.png',
    position: '5'
  }, {
    note: 'D',
    image: 'd-left.png',
    position: '4'
  }, {
    note: 'E',
    image: 'e-left.png',
    position: '3'
  }, {
    note: 'F',
    image: 'f-left.png',
    position: '2'
  }, {
    note: 'G',
    image: 'g-left.png',
    position: '1'
  }, {
    // right hand
    note: 'C',
    image: 'c2.png',
    position: '1'
  }, {
    note: 'D',
    image: 'd2.png',
    position: '2'
  }, {
    note: 'E',
    image: 'e2.png',
    position: '3'
  }, {
    note: 'F',
    image: 'f2.png',
    position: '4'
  }, {
    note: 'G',
    image: 'g2.png',
    position: '5'
  }
];

let currentNoteNr = getRandomNoteNr();

function getRandomNoteNr() {
  const max = notes.length;
  return Math.floor(max * Math.random());
}

const NoteStore = assign({}, GenericStore, {
  setNewNoteNr: function() {
    currentNoteNr = getRandomNoteNr();
    this.emitChange();
  },

  getNoteNr: function() {
    return currentNoteNr;
  },

  getNote: function(noteNr) {
    return notes[noteNr].note;
  },

  getImage: function(noteNr) {
    return notes[noteNr].image;
  },

  getCurrentImage: function() {
    return notes[currentNoteNr].image;
  },

  isCurrentNote: function(note) {
    return (notes[currentNoteNr].note === note) || (notes[currentNoteNr].position === note);
  }

});

export default NoteStore;
